/* eslint-disable unicorn/no-keyword-prefix */
import { TooltipComponent } from '@syncfusion/ej2-react-popups'
import { useEffect, useRef, useState, type JSX } from 'react'

interface ITooltipEllipsisProperties {
	content?: string | null | undefined | JSX.Element | number
	className?: string
}

const HSTooltipWithEllipsis: React.FC<ITooltipEllipsisProperties> = (
	properties: ITooltipEllipsisProperties
) => {
	const { content, className } = properties
	const textReference = useRef<HTMLDivElement>(null)
	const [isOverflowing, setIsOverflowing] = useState(false)

	useEffect(() => {
		const checkOverflow = () => {
			if (textReference.current) {
				setIsOverflowing(
					textReference.current.scrollWidth > textReference.current.clientWidth
				)
			}
		}

		checkOverflow()
		globalThis.addEventListener('resize', checkOverflow) // Re-check on resize
		return () => globalThis.removeEventListener('resize', checkOverflow)
	}, [content])

	return (
		<span
			style={{
				width: 'inherit',
				overflow: 'hidden',
				textOverflow: 'ellipsis',
				whiteSpace: 'nowrap',
				textAlign: 'left'
			}}
		>
			{isOverflowing ? (
				<TooltipComponent content={content}>
					<div
						ref={textReference}
						style={{
							overflow: 'hidden',
							textOverflow: 'ellipsis',
							whiteSpace: 'nowrap'
						}}
						className={className}
					>
						{content}
					</div>
				</TooltipComponent>
			) : (
				<div
					ref={textReference}
					style={{
						overflow: 'hidden',
						textOverflow: 'ellipsis',
						whiteSpace: 'nowrap'
					}}
					className={className}
				>
					{content}
				</div>
			)}
		</span>
	)
}

export default HSTooltipWithEllipsis
